/*
 * <cart-notification> — o aviso que substitui o drawer ao adicionar na sacola.
 *
 * O tema JA procurava por este elemento: o `product-form` (product-variants.js) faz
 * `document.querySelector("cart-notification") || document.querySelector("cart-drawer")`
 * e conversa com o que achar. So que ele nunca existiu aqui — quem respondia era o drawer.
 * Implementando o mesmo contrato, o fluxo de adicionar continua o mesmo e nada em
 * product-variants.js precisa mudar.
 *
 * Contrato esperado: getSectionsToRender(), setActiveElement(el), renderContents(resposta).
 *
 * getSectionsToRender devolve vazio de proposito: o aviso e montado a partir do JSON que o
 * /cart/add.js ja devolve (titulo, imagem, variante), sem pedir render de section nenhuma.
 * Quem atualiza o contador do header e o updateCartCounters() do global.js.
 */
(function () {
  var SUMICO_MS = 6000;

  var SVG_NS = 'http://www.w3.org/2000/svg';

  // Monta SVG por DOM em vez de string: o titulo do produto vem do SELLER, nao da casa,
  // entao nada de innerHTML com dado de fora — texto sempre por textContent.
  function svg(paths, extras) {
    var el = document.createElementNS(SVG_NS, 'svg');
    el.setAttribute('viewBox', (extras && extras.viewBox) || '0 0 24 24');
    el.setAttribute('fill', 'none');
    el.setAttribute('stroke', 'currentColor');
    el.setAttribute('stroke-width', (extras && extras.width) || '1.8');
    el.setAttribute('stroke-linecap', 'round');
    el.setAttribute('stroke-linejoin', 'round');
    el.setAttribute('aria-hidden', 'true');
    paths.forEach(function (d) {
      var p = document.createElementNS(SVG_NS, d.circulo ? 'circle' : 'path');
      if (d.circulo) {
        p.setAttribute('cx', d.cx); p.setAttribute('cy', d.cy); p.setAttribute('r', d.r);
      } else {
        p.setAttribute('d', d);
      }
      el.appendChild(p);
    });
    return el;
  }

  function iconeOk() { return svg(['M4 12.5 9.5 18 20 6.5']); }
  function iconeErro() { return svg(['M12 8v5', 'M12 16.5v.01', { circulo: true, cx: 12, cy: 12, r: 9 }]); }
  function iconeX() { return svg(['M1 1 L11 11', 'M11 1 L1 11'], { viewBox: '0 0 12 12', width: '1.2' }); }

  function el(tag, classe, texto) {
    var n = document.createElement(tag);
    if (classe) n.className = classe;
    if (texto != null) n.textContent = texto;
    return n;
  }

  class StealsCartNotice extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.activeElement = null;
    }

    connectedCallback() {
      this.addEventListener('click', event => {
        if (event.target.closest('[data-notice-close]')) this.fechar();
      });
      // segurar o mouse em cima nao pode deixar o aviso fugir enquanto se le
      this.addEventListener('mouseenter', () => this.pausar());
      this.addEventListener('mouseleave', () => this.agendarSumico());
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.classList.contains('is-open')) this.fechar();
      });

      // erros de adicionar ja sao publicados pelo product-form; o aviso so escuta
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartError, evento => {
          this.mostrarErro(evento && (evento.message || evento.errors));
        });
      }
    }

    /* --- contrato que o product-form espera --- */

    getSectionsToRender() {
      return [];
    }

    setActiveElement(elemento) {
      this.activeElement = elemento;
    }

    renderContents(resposta) {
      var item = resposta && resposta.items ? resposta.items[0] : resposta;
      if (!item) return;

      // "TAMANHO 37" e nao "37": o nome da opcao vem no options_with_values do /cart/add.js
      var variante = '';
      if (Array.isArray(item.options_with_values)) {
        variante = item.options_with_values
          .filter(function (o) { return o && o.value && String(o.value).indexOf('Default') === -1; })
          .map(function (o) { return o.name + ' ' + o.value; })
          .join(' · ');
      }
      if (!variante && item.variant_title && item.variant_title.indexOf('Default') === -1) {
        variante = item.variant_title;
      }
      var imagem = item.image || item.featured_image?.url || '';

      // O drawer atualizava o contador do header de tabela: o updateCartCounters() morava
      // dentro do loop de sections do renderContents dele. Como aqui getSectionsToRender()
      // devolve vazio de proposito, o loop nunca roda — entao o aviso chama na mao.
      if (typeof updateCartCounters === 'function') updateCartCounters();

      this.pintar({
        tipo: 'ok',
        rotulo: 'Adicionado à sacola',
        titulo: item.product_title || item.title || '',
        detalhe: variante,
        imagem: imagem,
        acaoTexto: 'Ver sacola',
        acaoHref: (window.routes && window.routes.cart_url) || '/cart'
      });
    }

    /* --- estados --- */

    mostrarErro(mensagem) {
      this.pintar({
        tipo: 'erro',
        rotulo: 'Não foi possível adicionar',
        titulo: mensagem || 'Tente de novo em instantes.',
        detalhe: '',
        imagem: '',
        acaoTexto: '',
        acaoHref: ''
      });
    }

    pintar(dados) {
      this.textContent = '';

      var card = el('div', 'steals-notice__card');
      card.setAttribute('role', 'status');
      card.setAttribute('aria-live', 'polite');

      if (dados.imagem) {
        var img = document.createElement('img');
        img.className = 'steals-notice__img';
        img.width = 56;
        img.height = 56;
        img.alt = '';
        img.src = dados.imagem;
        card.appendChild(img);
      }

      var corpo = el('div', 'steals-notice__body');
      var rotulo = el('span', 'steals-notice__label');
      rotulo.appendChild(dados.tipo === 'erro' ? iconeErro() : iconeOk());
      rotulo.appendChild(document.createTextNode(dados.rotulo));
      corpo.appendChild(rotulo);
      corpo.appendChild(el('p', 'steals-notice__title', dados.titulo));
      if (dados.detalhe) corpo.appendChild(el('span', 'steals-notice__detail', dados.detalhe));
      if (dados.acaoTexto) {
        var link = el('a', 'steals-notice__link', dados.acaoTexto);
        link.href = dados.acaoHref;
        corpo.appendChild(link);
      }
      card.appendChild(corpo);

      var fechar = el('button', 'steals-notice__close');
      fechar.type = 'button';
      fechar.setAttribute('data-notice-close', '');
      fechar.setAttribute('aria-label', 'Fechar');
      fechar.appendChild(iconeX());
      card.appendChild(fechar);

      this.appendChild(card);
      this.dataset.tipo = dados.tipo;
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-open'));
      this.agendarSumico();
    }

    agendarSumico() {
      this.pausar();
      this.timer = setTimeout(() => this.fechar(), SUMICO_MS);
    }

    pausar() {
      if (this.timer) clearTimeout(this.timer);
      this.timer = null;
    }

    fechar() {
      this.pausar();
      this.classList.remove('is-open');
      setTimeout(() => {
        if (!this.classList.contains('is-open')) this.hidden = true;
      }, 260);
    }
  }

  if (!customElements.get('cart-notification')) {
    customElements.define('cart-notification', StealsCartNotice);
  }
})();
